export const articles = [
  {
    id: '1',
    slug: 'dingliu-wanghong-zhibo-fanche',
    title: '某千万粉丝网红直播翻车，私下贬低粉丝言论意外曝光引全网震怒',
    excerpt: '拥有超过两千万粉丝的知名美妆博主在近日一次直播中不慎将私下聊天记录露出，其中包含大量贬低粉丝消费能力的内容，引发全网哗然。',
    content: `<p>一场原本平淡无奇的带货直播，却因一个意外的屏幕共享操作，瞬间演变成年度最大翻车现场。拥有超过两千万粉丝的知名美妆博主"Lily姐"在近日一次直播中，不慎将私下与助理的聊天记录完整展示在数万观众面前。</p>
    <p>聊天记录中，Lily姐直言"那些粉丝都是穷鬼，买个三十块钱的面膜还要犹豫半天"，甚至嘲讽粉丝"智商税真好赚"。更令人震惊的是，她还透露了多款产品的真实成本，其中一款售价199元的精华液，出厂价仅有12元。</p>
    <p>事情发生后，相关话题迅速登上各大社交平台热搜榜。大量粉丝涌入评论区表达愤怒，纷纷表示"脱粉脱到连渣都不剩"。截至目前，Lily姐的账号已掉粉超过300万，多个品牌方紧急发布声明宣布终止合作。</p>
    <p>业内人士分析指出，这次事件给整个网红行业敲响了警钟。在流量至上的时代，部分网红已完全脱离初心，将粉丝仅仅视为变现工具。一旦这层窗户纸被捅破，崩塌就在一瞬间。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20editorial%20photography%20of%20a%20beauty%20influencer%20studio%20setup%20with%20makeup%20products%20scattered%20on%20a%20white%20marble%20table%2C%20soft%20natural%20lighting%20from%20a%20large%20window%2C%20clean%20aesthetic%20composition%20with%20warm%20beige%20and%20cream%20tones%2C%20shallow%20depth%20of%20field%2C%20magazine%20editorial%20style%2C%20high%20detail%2C%20professional%20product%20photography&width=1200&height=800&seq=article-cover-01&orientation=landscape',
    category: 'wanghong-fanche',
    tags: ['直播翻车', '网红爆料', 'Lily姐', '美妆博主'],
    publishDate: '2026-06-30',
    viewCount: 2856000,
    commentCount: 18342,
    author: '91爆料编辑部',
    isHot: true,
    isVideo: false,
  },
  {
    id: '2',
    slug: 'dingliu-mingxing-lianqing-shichui',
    title: '顶流男星深夜密会神秘女子，恋情疑似实锤？知情人士曝更多细节',
    excerpt: '当红顶流男星被拍到深夜与一位神秘女子同返住所，两人举止亲密。据知情人士透露，该女子并非圈内人，两人已交往半年有余。',
    content: `<p>娱乐圈又一对疑似新恋情浮出水面。近日，当红顶流男星张某某被娱记拍到深夜与一位神秘女子同返其位于北京朝阳区的住所，两人全程举止亲密，关系非同一般。</p>
    <p>据拍摄画面显示，当天晚上十一点左右，张某某驾驶一辆黑色奔驰商务车出现在某高档小区地下车库。一位身材高挑、穿着低调的长发女子从副驾驶下车，两人一前一后进入电梯，期间张某某还贴心地为对方拎着购物袋。</p>
    <p>知情人士向本网透露，该神秘女子姓陈，今年25岁，毕业于某知名音乐学院，目前在一家艺术机构工作，并非娱乐圈人士。两人是通过共同朋友介绍认识，已低调交往半年有余。</p>
    <p>截至目前，张某某的工作室尚未对此事做出回应。其粉丝群体反应两极分化，部分粉丝表示"尊重偶像私生活"，也有不少女友粉在社交平台表达了失落情绪。值得一提的是，张某某此前在多个公开场合曾表示"以事业为重，暂时不考虑恋爱"，此次爆料若属实，或将对其人设造成一定影响。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Warm%20toned%20editorial%20night%20photography%20of%20a%20luxury%20apartment%20building%20entrance%20in%20a%20modern%20city%2C%20soft%20ambient%20street%20lighting%2C%20dark%20sedan%20parked%20in%20front%2C%20cinematic%20atmosphere%20with%20warm%20amber%20streetlights%2C%20clean%20composition%2C%20magazine%20editorial%20style%2C%20high%20contrast%2C%20dramatic%20mood&width=1200&height=800&seq=article-cover-02&orientation=landscape',
    category: 'yulequan',
    tags: ['恋情曝光', '顶流明星', '深夜密会', '娱乐圈八卦'],
    publishDate: '2026-06-29',
    viewCount: 4521000,
    commentCount: 25671,
    author: '91爆料编辑部',
    isHot: true,
    isVideo: false,
  },
  {
    id: '3',
    slug: 'baiwan-fensi-bozhu-zaojia',
    title: '百万粉丝博主被曝数据造假，真实粉丝竟不足千人？平台已介入调查',
    excerpt: '某短视频平台拥有百万粉丝的美食博主，被技术博主通过数据分析揭露其粉丝99%为僵尸粉，真实互动粉丝仅几百人，目前平台方已启动调查程序。',
    content: `<p>百万粉丝博主的真实影响力究竟有多大？一位技术类博主近日通过公开数据分析，揭露了某知名美食博主粉丝数据的惊人真相——在超过120万的粉丝中，真实活跃用户可能不足1000人。</p>
    <p>该技术博主通过分析该美食博主近30天的视频数据发现，其视频平均播放量仅3000次左右，点赞和评论数也远低于同级别博主的正常水平。更关键的是，粉丝增长曲线呈现出明显的"阶梯式"特征——在多个时间段内，粉丝数在短短几分钟内暴增数万。</p>
    <p>"这明显是批量购买僵尸粉的特征，"该技术博主在视频中解释道，"正常的粉丝增长应该是相对平滑的曲线，而这种断崖式增长只有通过第三方刷量平台才能实现。"</p>
    <p>事件发酵后，该美食博主的账号评论区涌入大量质疑声音。有品牌方表示，曾以数万元价格与其合作推广，现在正在考虑追究其虚假宣传的责任。目前，涉事短视频平台已发布声明，表示将对该账号进行核查，如情况属实将严肃处理。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Clean%20minimalist%20overhead%20photography%20of%20smartphone%20screen%20displaying%20social%20media%20analytics%20dashboard%20with%20graphs%20and%20numbers%2C%20on%20a%20light%20wooden%20desk%20surface%2C%20soft%20natural%20lighting%2C%20warm%20neutral%20tones%2C%20editorial%20style%2C%20high%20detail%2C%20professional%20composition&width=1200&height=800&seq=article-cover-03&orientation=landscape',
    category: 'wanghong-fanche',
    tags: ['数据造假', '僵尸粉', '百万博主', '平台调查'],
    publishDate: '2026-06-28',
    viewCount: 1893000,
    commentCount: 12450,
    author: '91爆料编辑部',
    isHot: true,
    isVideo: false,
  },
  {
    id: '4',
    slug: 'zongyi-jiemu-neimu-baoguang',
    title: '某热门综艺节目内幕大曝光：剧本安排、选手关系全是演的？',
    excerpt: '一位曾参与某热门综艺节目的工作人员匿名爆料，揭露节目组如何通过剧本操控剧情走向和选手人设，所谓"真实反应"背后全是精心设计。',
    content: `<p>你追的综艺节目，到底有多少是真实发生的？一位自称曾参与某档热门综艺节目制作的工作人员，近日通过匿名方式向本网爆料，揭露了节目制作中不为人知的"剧本操作"。</p>
    <p>据该爆料人透露，这档以"真人秀"为卖点的综艺节目，实际上每期都有详细的剧本大纲。不仅选手之间的"矛盾冲突"是导演组刻意安排的，甚至连选手的性格人设都是提前设计好的——谁是"耿直担当"、谁是"泪点担当"，都有明确的角色分工。</p>
    <p>"选手在台上看起来很真实的情绪爆发，其实在录制之前导演就会跟他们沟通，'待会你需要哭一下，配合一下现场气氛'，"该工作人员表示，"有时候一个精彩片段要反复录四五遍才能达到导演要的效果。"</p>
    <p>此外，节目的淘汰机制也存在猫腻。据称，部分选手的晋级与否在比赛开始前就已内定，投票环节更多是为了营造悬念感。这则爆料引发网友热议，不少人表示"虽然早就猜到有剧本，但知道得这么详细后还是觉得被欺骗了"。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Dramatic%20editorial%20photography%20of%20a%20TV%20studio%20set%20with%20bright%20stage%20lights%20and%20empty%20audience%20seats%2C%20behind%20the%20scenes%20perspective%2C%20warm%20spotlight%20beams%2C%20cinematic%20lighting%20with%20deep%20shadows%2C%20clean%20composition%2C%20magazine%20editorial%20style%2C%20high%20contrast%2C%20atmospheric%20mood&width=1200&height=800&seq=article-cover-04&orientation=landscape',
    category: 'yulequan',
    tags: ['综艺内幕', '节目剧本', '真人秀造假', '娱乐圈爆料'],
    publishDate: '2026-06-27',
    viewCount: 3210000,
    commentCount: 19843,
    author: '91爆料编辑部',
    isHot: true,
    isVideo: false,
  },
  {
    id: '5',
    slug: 'zhiming-zhubo-tuandui-neihong',
    title: '知名游戏主播团队内讧实锤，核心成员深夜发文宣布出走',
    excerpt: '拥有千万粉丝的知名游戏主播团队内部矛盾全面爆发，多位核心成员在社交平台互相指责，其中一位联合创始人已正式宣布离开团队。',
    content: `<p>直播圈再次上演"分家"大戏。拥有千万粉丝的知名游戏主播团队"星辰公会"近日爆发严重内讧，核心成员之间在社交平台上公开互怼，撕破脸皮的场面令粉丝震惊。</p>
    <p>矛盾的导火索是团队收益分配问题。出走成员"阿飞"在深夜发布的长文中控诉，自己作为联合创始人之一，在团队最困难的初创期投入了大量精力和资金，但在团队走红后的收益分配上却被逐渐边缘化。"从每月固定分成变成了一笔打发人的'辛苦费'，这种落差谁受得了？"</p>
    <p>对此，团队主理人"星哥"迅速做出回应，否认了所有指控，称阿飞是因为个人能力跟不上团队发展被降级后心生不满。双方各执一词，粉丝阵营也因此分裂，直播间的弹幕区变成了"战场"。</p>
    <p>业内人士分析认为，主播团队的"分家"现象近年来愈发频繁，背后反映出的是网红经济野蛮生长后必然要面对的规范化问题——缺乏完善的合伙协议和利益分配机制，仅靠"兄弟情谊"维系的合作关系往往经不起利益的考验。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Warm%20toned%20editorial%20photography%20of%20a%20gaming%20streaming%20setup%20with%20multiple%20monitors%20and%20RGB%20lighting%2C%20gaming%20chair%20empty%20in%20a%20dark%20room%2C%20dramatic%20atmosphere%2C%20soft%20ambient%20light%2C%20clean%20composition%2C%20magazine%20editorial%20style%2C%20high%20detail%2C%20cinematic%20mood&width=1200&height=800&seq=article-cover-05&orientation=landscape',
    category: 'wanghong-fanche',
    tags: ['主播内讧', '团队分裂', '游戏主播', '收益分配'],
    publishDate: '2026-06-26',
    viewCount: 1678000,
    commentCount: 9876,
    author: '91爆料编辑部',
    isHot: false,
    isVideo: false,
  },
  {
    id: '6',
    slug: 'wanghong-daihuo-zhiliang-wenti',
    title: '网红带货又翻车！某知名主播推荐产品被曝严重质量问题，消费者集体维权',
    excerpt: '一位拥有500万粉丝的带货主播推荐的某品牌美容仪，被大量消费者反映使用后出现皮肤过敏、机器漏电等严重问题，目前已引发集体维权行动。',
    content: `<p>网红带货翻车事件再添新案例。近日，拥有500万粉丝的带货主播"美美哒"推荐的一款售价899元的美容仪，被大量购买者爆出严重质量问题，一场声势浩大的消费者维权行动正在进行中。</p>
    <p>据维权群内消费者反馈，这款美容仪在使用过程中出现了多种问题：部分用户反映使用后面部出现红肿、刺痛等过敏症状；更有用户称机器在使用过程中出现了漏电情况，"手都被电麻了"。此外，产品的材质和做工也与直播中展示的样品存在明显差异。</p>
    <p>面对消费者的投诉，该主播最初回应称"产品质量没有问题，是个别用户使用不当导致的"，但这一回应反而进一步激怒了消费者。随后有网友扒出，该美容仪的实际生产厂家是一家注册资本仅10万元的小作坊，与直播中宣传的"国际大牌代工厂"完全不符。</p>
    <p>目前，已有超过2000名消费者加入了维权群，部分用户已向市场监管部门进行了投诉举报。法律人士指出，主播作为产品的推荐者和销售者，对产品质量负有不可推卸的责任，消费者有权要求退一赔三。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Editorial%20photography%20of%20a%20beauty%20device%20on%20a%20minimalist%20white%20background%2C%20clean%20product%20photography%20style%2C%20soft%20diffused%20lighting%2C%20neutral%20cream%20and%20beige%20tones%2C%20elegant%20composition%2C%20magazine%20editorial%20style%2C%20high%20detail%2C%20professional%20commercial%20photography&width=1200&height=800&seq=article-cover-06&orientation=landscape',
    category: 'dujia-baoliao',
    tags: ['带货翻车', '产品质量', '消费者维权', '美容仪'],
    publishDate: '2026-06-25',
    viewCount: 2340000,
    commentCount: 15678,
    author: '91爆料编辑部',
    isHot: false,
    isVideo: false,
  },
  {
    id: '7',
    slug: 'daoyan-yanyuan-buhe-neimu',
    title: '娱乐圈震撼弹：知名导演与一线演员片场激烈争吵，两人多年不合内幕曝光',
    excerpt: '某知名导演与一线男星在片场爆发激烈争执，甚至一度中断拍摄。据剧组工作人员爆料，两人矛盾由来已久，此次冲突只是长期积怨的集中爆发。',
    content: `<p>娱乐圈表面光鲜亮丽的合作关系背后，究竟隐藏着多少不为人知的矛盾？近日，知名导演王某某与一线实力派男星李某在某电影片场爆发激烈争吵的消息，在圈内引发了轩然大波。</p>
    <p>据现场工作人员透露，争执的起因是李某对导演临时修改剧本的做法表达了不满。"导演凌晨三点发新的剧本过来，要求第二天一早就按新的演，完全不给人准备的时间，李老师当场就爆了。"该工作人员描述道。</p>
    <p>但事情并不只是改剧本这么简单。有知情人士爆料，两人之间的不和由来已久。早在三年前合作的第一部电影时，导演就曾在私下场合表示李某"演技被严重高估"，这番话后来传到了李某耳中。此后两人虽然表面维持着合作关系，但私下已是水火不容。</p>
    <p>目前，这部电影的拍摄已暂停。制片方正在紧急协调双方的矛盾，但据称李某已有退出剧组的意向。如果此事成真，不仅将造成巨大的经济损失，更可能波及整个项目的后续档期安排。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Cinematic%20photography%20of%20empty%20film%20set%20with%20professional%20camera%20equipment%20and%20lighting%20rigs%2C%20director%20chair%20in%20foreground%2C%20dramatic%20atmosphere%20with%20warm%20and%20cool%20lighting%20contrast%2C%20clean%20composition%2C%20magazine%20editorial%20style%2C%20high%20detail%2C%20cinematic%20mood&width=1200&height=800&seq=article-cover-07&orientation=landscape',
    category: 'yulequan',
    tags: ['导演演员', '片场冲突', '娱乐圈内幕', '电影制作'],
    publishDate: '2026-06-24',
    viewCount: 1987000,
    commentCount: 11234,
    author: '91爆料编辑部',
    isHot: false,
    isVideo: false,
  },
  {
    id: '8',
    slug: 'duanshipin-dav-shuju-zaojia',
    title: '短视频平台百万粉大V数据造假产业链曝光：刷量工作室月入百万',
    excerpt: '本网记者潜伏调查发现，一条完整的短视频数据造假产业链已经形成。专业刷量工作室通过技术手段为网红提供点赞、评论、播放量等服务，月流水高达百万。',
    content: `<p>在短视频平台上看到的热门内容，有多少数据是真实的？本网记者经过为期两个月的深入调查，揭露了一条隐藏在光鲜数据背后的灰色产业链——专业刷量工作室。</p>
    <p>调查发现，这些刷量工作室的业务范围涵盖了数据造假的方方面面：粉丝购买、播放量刷量、点赞评论、话题冲榜等。价格也相当"亲民"：1000个真人粉丝约50元，1万次播放量仅需30元，定制化的"高级套餐"则可能达到数千元。</p>
    <p>一位化名"阿杰"的刷量工作室负责人向记者透露，他们的客户中不乏平台上粉丝数百万的知名大V。"很多你以为的大网红，早期都是靠刷量起来的。先把数据堆上去，平台算法就会给更多自然流量，然后再慢慢洗白。"</p>
    <p>据其介绍，运营得好的刷量工作室月流水可以达到百万元以上。更令人震惊的是，部分平台内部人员也可能参与其中，通过"内推"机制帮助客户获得更多曝光。目前，相关部门已经注意到这一问题，多家短视频平台也表态将加大打击力度。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Editorial%20photography%20of%20a%20dark%20room%20with%20multiple%20smartphone%20screens%20displaying%20social%20media%20apps%2C%20arranged%20on%20a%20desk%2C%20mysterious%20atmosphere%20with%20dim%20ambient%20lighting%2C%20warm%20screen%20glow%2C%20clean%20composition%2C%20magazine%20investigative%20style%2C%20high%20detail%2C%20dramatic%20mood&width=1200&height=800&seq=article-cover-08&orientation=landscape',
    category: 'dujia-baoliao',
    tags: ['数据造假', '刷量产业链', '短视频', '暗访调查'],
    publishDate: '2026-06-23',
    viewCount: 3120000,
    commentCount: 20123,
    author: '91爆料编辑部',
    isHot: false,
    isVideo: false,
  },
  {
    id: '9',
    slug: 'xuanxiu-jiemu-heimu-caozuo',
    title: '选秀节目黑幕操作全记录：票数造假、导师暗箱、资本操控一条龙',
    excerpt: '一位曾参与多档选秀节目的资深业内人士决定站出来，全面揭露选秀节目背后的资本运作逻辑和票数造假手段，让观众看清所谓的"全民制作"真相。',
    content: `<p>"你投的每一票，其实早就不重要了。"一位在选秀行业摸爬滚打了十几年的资深幕后人士，近日接受了本网的独家专访，系统性地揭示了选秀节目中的种种黑幕操作。</p>
    <p>据这位化名"老K"的业内人士透露，选秀节目的票数造假几乎是公开的秘密。节目组会通过后台技术手段对票数进行"加权调整"，以确保最终晋级的选手符合资本方的预期。"有时候一个选手的真实票数排名可能在十几名开外，但通过数据调整就能进入前三。"</p>
    <p>除了票数问题，导师点评也有猫腻。老K表示，导师收到的选手名单上已标注了"重点推荐"和"建议淘汰"的标签，"导师的点评基本都是按照这个方向去发挥的，很少有导师会真的凭自己判断来。"</p>
    <p>这一切的背后，是资本的力量在操控。赞助商、经纪公司、平台方形成了稳固的利益三角，他们共同决定了谁能走到最后。而观众，只是这场资本游戏的"群众演员"，他们的热情和真情实感，最终都只是数字游戏中的一环。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Dramatic%20editorial%20photography%20of%20a%20talent%20show%20stage%20with%20bright%20spotlights%20and%20fog%20effects%2C%20empty%20stage%20perspective%2C%20cinematic%20lighting%20with%20dramatic%20shadows%2C%20warm%20golden%20and%20cool%20blue%20contrast%2C%20clean%20composition%2C%20magazine%20editorial%20style%2C%20high%20detail%2C%20theatrical%20atmosphere&width=1200&height=800&seq=article-cover-09&orientation=landscape',
    category: 'yulequan',
    tags: ['选秀黑幕', '票数造假', '资本操控', '业内爆料'],
    publishDate: '2026-06-22',
    viewCount: 2789000,
    commentCount: 22156,
    author: '91爆料编辑部',
    isHot: true,
    isVideo: false,
  },
  {
    id: '10',
    slug: 'wanghongquan-dadizhen-duoren-fengbo',
    title: '网红圈大地震：一周内五位博主卷入负面风波，有人直接退网',
    excerpt: '过去一周堪称网红圈的"黑色星期"，先后有五位拥有百万粉丝的博主因不同原因卷入负面风波，其中一位拥有八百万粉丝的头部网红已宣布永久退网。',
    content: `<p>这一周，对于网红圈来说注定是不平凡的一周。短短七天之内，先后有五位百万粉级别的博主卷入了不同程度的负面风波，被网友戏称为"网红圈大地震"。</p>
    <p>率先引爆舆论的是拥有八百万粉丝的生活类博主"小确幸日记"，她因被扒出人设造假——其精心营造的"独居租房打工人"形象完全是虚构的，实际家境优渥且名下有多套房产——而遭到全网声讨。在舆论压力之下，她选择了永久退网。</p>
    <p>紧随其后，搞笑博主"段子手阿强"被前员工实名举报拖欠工资及职场霸凌；美妆博主"糖果Candy"因涉嫌抄袭国外博主创意内容被实锤；健身博主"铁人Jason"被曝使用违禁药物维持体态；美食博主"吃货一哥"则因食品安全问题被市场监管部门约谈。</p>
    <p>有行业观察者指出，这一轮密集爆发的网红负面事件并非巧合，而是行业在野蛮生长多年后必然经历的洗牌期。随着监管趋严和粉丝理性回归，那些依靠虚假人设和低质内容起家的网红，终将被淘汰出局。</p>`,
    coverImage: 'https://readdy.ai/api/search-image?query=Editorial%20photography%20of%20broken%20smartphone%20screen%20on%20a%20minimalist%20surface%2C%20cracked%20glass%20reflecting%20warm%20light%2C%20dramatic%20lighting%20with%20deep%20shadows%2C%20clean%20aesthetic%20composition%2C%20magazine%20editorial%20style%2C%20high%20detail%2C%20conceptual%20mood&width=1200&height=800&seq=article-cover-10&orientation=landscape',
    category: 'zuixin-dagua',
    tags: ['网红圈', '负面风波', '退网', '行业洗牌'],
    publishDate: '2026-06-21',
    viewCount: 5120000,
    commentCount: 31245,
    author: '91爆料编辑部',
    isHot: true,
    isVideo: false,
  },
];

export const getHotArticles = () => articles.filter(a => a.isHot);
export const getArticlesByCategory = (slug: string) => articles.filter(a => a.category === slug);
export const getArticleBySlug = (slug: string) => articles.find(a => a.slug === slug);